import { render, staticRenderFns } from "./SaveBar.vue?vue&type=template&id=6ed8d4a0&"
import script from "./SaveBar.vue?vue&type=script&lang=js&"
export * from "./SaveBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports